module.exports = __webpack_public_path__ + "static/media/22_blanco.154e4c0a.svg";